/**
 * Dimensions a BoM may be aggregated by, in addition to the material itself.
 *
 * `takeOffId` is satisfied structurally — records are already partitioned by take-off
 * type and then by take-off id before the joining key is built — so it is accepted for
 * readability but contributes nothing to the key.
 *
 * ! It is named for the take-off *id*, not the type, because the id is what the rows are
 * ! actually grouped by and it encodes both type and level (`wholeHouseExtFramingLevel1`).
 * ! Level is therefore not separately groupable; it is already inside this dimension.
 *
 * `packageName` groups per package, not per drawing area: several canvases can carry the
 * same package and together make up one delivery, so they belong on a single row. Renaming a
 * package therefore changes the rows it produced, and any package override keyed on them is
 * pruned. Stored configurations and transaction snapshots may still say `imageName`, its
 * former name; readers map it with `legacyDimensionNames`.
 *
 * Add a new dimension here and give it a case in `CanvasBoMService.joiningKey`.
 */
export const dimensions = ['packageName', 'takeOffId', 'usage'] as const;

/** Former names of dimensions, as stored configurations and snapshots may still hold them. */
export const legacyDimensionNames = { imageName: 'packageName' } as const;
